// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../../common/Components/Form.bs.js");
let Form__TextInput = require("../../common/Components/Form__TextInput.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");

function PropertyWizardRelay__Description__Subject(props) {
  let subject = props.subject;
  let match = PropertyWizardFormRelay.Context.use();
  let remainingChars = PropertyWizardFormRelay__Validators__Description.Subject.subjectLengthLimit - subject.valueAsString.length | 0;
  let tmp;
  let tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" || tmp$1.TAG !== "Rebroadcast" ? "For example: Remodeled home with level yard and ocean views" : "For example: Price reduction coming this week at Union SF";
  let match$1 = subject.focused;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    children: [
      JsxRuntime.jsx(Form__TextInput.make, {
        labelText: "Headline",
        placeholderText: tmp,
        onChange: event => subject.onChange(event.currentTarget.value),
        onBlur: param => subject.onBlur(),
        onFocus: param => subject.onFocus(),
        status: subject.status,
        value: subject.valueAsString
      }),
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: subject.valid
      }),
      match$1 && remainingChars <= 30 && remainingChars >= 0 ? JsxRuntime.jsx(Form.Warning.make, {
          children: remainingChars.toString() + " characters remaining"
        }) : null
    ]
  });
}

let Components;

let TextInputField;

let Cell;

let Validators;

let FormUtils;

let make = PropertyWizardRelay__Description__Subject;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.make = make;
/* Form Not a pure module */
